<template>
  <ul id="bic-search-menu" class="primary-nav__list">
    <li class="primary-nav__item" v-bind:class="{ 'primary-nav__item--current': mode === 'default' }">
      <router-link class="primary-nav__link" to="/">Home</router-link>
    </li>
    <li class="primary-nav__item" v-bind:class="{ 'primary-nav__item--current': mode === 'browse' }">
      <router-link class="primary-nav__link" to="/browse/class">Browse for a code</router-link>
    </li>
    <li class="primary-nav__item" v-bind:class="{ 'primary-nav__item--current': mode === 'search' }">
      <router-link class="primary-nav__link" to="/search">Search for a code</router-link>
    </li>
    
  </ul>
</template>

<script>
  import Vue from 'vue';
  import router from './router/index.js';
  
  export default Vue.component('AppMenu', {
    props: {
      mode: String,
    }
  });
</script>